<template>
  <div class="diagnose-wrapper">

    <!-- 诊断信息 -->
    <div class="diagnose-section">

      <div class="diagnose-info-item">
        <div class="diagnose-title"><span class="required">就诊人</span></div>
        <div class="info-content">
          <div class="patient-info">{{patientInfo.username}} {{patientInfo.gender | genderFilter}}
            {{patientInfo.birthday | ageFilter}} {{(patientInfo.allergy == '否认') ? '无过敏史' : patientInfo.allergy == '不确定' ? '不确定过敏史' : patientInfo.allergy}}</div>
        </div>
      </div>


    </div>
    <div class="photo-description">
      <div class="des-title">注意事项</div>
      <p class="tips-block">
        <icon icon-class="tips"></icon>图片必须包含以下内容才能形成电子处方
      </p>
      <p>(1)请保证文字书写规范可识别。
      </p>
      <p>(2)患者信息：姓名、性别、年龄。
      </p>
      <p>(3)处方信息：主诉、诊断、药方、用法用量。
      </p>
      <p>(4)注意事项：十八反药材，超剂量毒性药材需要在对应药材后签字。
      </p>
    </div>
    <div class="photo-control" v-if="hasPresData">
      <div class="upload-box">
        <div class="upload-item">
          <img :src="presPath" style="width: 100%;">
        </div>
      </div>
    </div>
    <div v-if="!hasPresData">
      <div class="photo-control">
        <div class="upload-box">
          <div class="upload-item" @click="wxUpload()">
            <div class="upload-placeholder" v-if="!presPreview">
              <img src="@/assets/images/icons/upload-pres.png" style="width: 60px;">
              <p>上传处方</p>
            </div>
            <div class="preview-box" v-else>
              <img :src="presPreview">
              <div class="upload-status" :class="{'done': presFile.status == 5}" v-if="presFile && presFile.status">{{presFile.status | uploadStatus}}</div>
            </div>
          </div>
          <div class="upload-item">
            <div class="upload-placeholder" @click="previewImage(previewList, 0)">
              <img src="@/assets/images/icons/phpto-pres-example.jpg" style="width: 75%;">
              <p>处方示例</p>
            </div>
          </div>

        </div>
      </div>
      <div class="form-wrapper">
        <div class="form-item click" :class="{'error': drugsError}" @click="drugsPickerShow = true">
          <div class="form-type"><span class="required">药品类型（颗粒|饮片）</span></div>
          <div class="form-content">
            <div class="picker-tips" v-if="!drugs">请选择
              <icon icon-class="arrow" />
            </div>
            <div class="picker-value" v-else>{{this.drugs | formulationTypeFilter}}</div>
          </div>
          <div class="form-error" v-if="drugsError">
            <van-icon name="fail" />{{drugsErrorMsg}}</div>
        </div>
      </div>
    </div>
<!--
    <div class="upload-placeholder" v-if="userInfo.user_id==10032" @click="wxUpload()">
      <img src="@/assets/images/icons/upload-pres.png" style="width: 60px;">
      <p>微信上传</p>
    </div>
-->
    <div class="photo-tips">
      <p>*电子处方生成时间：工作日09:00-22:00,超过当日生成时间的顺延至下个工作日生成。
      </p>
    </div>
    <div class="bottom-control" v-if="!hasPresData">
      <button class="botton-button send" :disabled="submitting" @click="submit">提交</button>
    </div>
    <div style="height: 40px;" v-if="hasPresData"></div>
    <div class="bottom-tips" v-if="hasPresData">
      您的处方还在生成中，请耐心等待...
    </div>
    <van-image-preview v-model="previewShow" :images="previewList" :start-position="imageIndex"></van-image-preview>
    <!-- 弹出层 -->
    <!-- 药品类型选择 -->
    <van-popup v-model="drugsPickerShow" position="bottom">
      <van-picker show-toolbar :columns="drugsData" value-key="label" @cancel="drugsPickerShow = false" @confirm="confirmDrugs" />
    </van-popup>
    <!-- 弹窗 -->
    <!-- 保存处方模板弹窗 -->
    <!--
      <x-dialog v-if="saveToTemplateShow" title="保存为处方模板" @close="saveToTemplateShow = false">
        <div class="save-content">
          <div class="save-input">
            <div class="save-title">模板名称</div>
            <div class="save-text">
              <input type="text" class="save-typer" maxlength="15" v-model="saveTemplateName" placeholder="请输入处方名称">
              <span class="text-limit">{{saveTemplateName.length}}/15</span>
            </div>
          </div>
          <div class="save-control">
            <button class="cancel" @click="saveToTemplateShow = false">取消</button>
            <button class="confirm" @click="saveTemplateAction" :disabled="scriptSaving">保存</button>
          </div>
        </div>
      </x-dialog>
      -->
    <!-- 发送给患者弹窗 -->
    <!--
      <x-dialog v-if="sendScriptShow" title="发送处方" @close="sendScriptShow = false">
        <div class="dialog-content">
          <div class="warning-text" v-if="overDosage">当前处方用量超过7天，请确认已知晓，并将处方发送给患者</div>
          <div class="text" v-else>是否将处方发送给患者</div>
          <div class="control">
            <button class="cancel" @click="sendScriptShow = false">再修改一下</button>
            <button class="confirm" @click="sendScript">确定</button>
          </div>
        </div>
      </x-dialog>
-->

  </div>
</template>

<style lang="less" scoped>
  .bottom-tips{
    height: 30px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    line-height: 30px;
    font-size: 13px;
    color:#fff;
    background-color: #ff7300;

  }
  .form-wrapper{
    padding: 24px 0 12px;
    margin-top: 12px;
    background: #FFF;
    .upload-avatar-box{
      width: 100%;
      .van-uploader__input-wrapper{
        width: 100%;
      }
    }
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-textarea{
            border: 1px solid #F7F7F7;
            background: #F7F7F7;
            resize: none;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            width: 100%;
            height: 144px;
            &::-webkit-input-placeholder{
              color: #999;
            }
          }
          .textarea-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            color: #999;
          }
        }
      }
      &.avatar{
        height: 80px;
        margin-bottom: 12px;
      }
      &.click{
        cursor: pointer;
        &:active{
          background: #F9F9F9;
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      .form-type{
        font-size: 14px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        .avatar-box{
          width: 64px;
          height: 64px;
          overflow: hidden;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 100%;
            // height: 100%;
          }
        }
        .form-text{
          width: 200px;
          border: 0;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .picker-tips{
          font-size: 16px;
          color: #999;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            position: relative;
            top: 2px;
            font-size: 14px;
            margin-left: 4px;
          }
        }
        .picker-value{
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .get-code-button{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 32px;
          border: 1px solid @xile;
          color: @xile;
          font-weight: bold;
          background: transparent;
          font-size: 12px;
          border-radius: 4px;
          transition: all .1s;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
            &:active{
              opacity: 1;
            }
          }
          &:active{
            opacity: .8;
          }
        }
      }
      .code-input-box{
        .code-input{
          width: 200px;
          border: 0;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .bottom-control{

    margin:20px auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 0;
    .botton-button{
      @button-base();
      height: 40px;
      &.save{
        width: 128px;
        @button-border();
        .xile-alpha(0.05);
        &:disabled{
          opacity: .6;
        }
      }
      &.send{

        flex: 1;
      }
    }
  }
  .photo-control{
    width: 96%;
    margin:2px auto;
    border:dashed 1px #ddd;
    border-radius: 3px;
    background-color: #e9eef5;
    padding:5px 1%;
    .upload-box{
      display: flex;
      justify-content:space-around;
      align-items: space-around;;
      padding-left: 8px;
      .upload-item{

        // width: 156px;
        flex: 1;
        max-width: 156px;

        overflow: hidden;
        margin-right: 15px;
        &:last-child{
          margin-right: 0;
        }
        .upload-placeholder{
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          // width: 156px;
          width: 100%;
          height: 100px;
          background: #F3F3F3;
          border: 1px dashed #CCC;
          border-radius: 4px;
          text-align: center;
          color: #CCC;
          font-size: 12px;
          svg{
            font-size: 32px;
          }
          p{
            margin-top: 12px;
          }
        }
        .preview-box{
          position: relative;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          // width: 156px;
          width: 100%;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
          border: 1px dashed #CCC;
          img{
            width: 156px;
          }
          .upload-status{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 24px;
            color: #FFF;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            background: rgba(0, 0, 0, .4);
            transition: all .2s;
            &.done{
              background: @xile;
            }
          }
        }
      }
    }


  }
  .photo-tips{
    width: 96%;
    margin:8px auto;
    border-top:dashed 1px #ddd;
    border-radius: 3px;
    height: 60px;
    padding:5px 1%;
    p{
      color:#F5A41E;
      font-size: 13px;
      line-height: 18px;
      padding: 3px 2px;
      margin:0;

    }
  }
  .photo-description{
        width: 96%;
        margin:2px auto;
        border:dashed 1px #ddd;
        border-radius: 3px;
        background-color: #e9eef5;
        padding:5px 1%;
        p{
          color:#333333;
          font-size: 14px;
          line-height: 18px;
          padding: 3px 2px;
          margin:0;

        }
        .des-title{
          color:#333333;
          font-size: 16px;
          font-weight: bold;
        }
        .tips-block{
          display: flex;
          justify-content:flex-start;
          align-items: flex-start;
          padding: 7px 2px;
          background: rgba(245,164,30,0.05);
          border-radius: 2px;
          color: #F5A41E;
          font-size: 13px;
          line-height: 18px;
          svg{
            position: relative;
            top: 3px;
            flex-shrink: 0;
            margin-right: 6px;
            font-size: 13px;
            line-height: 18px;
            color: #F5A41E;
          }
        }
  }
  .diagnose-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    width: 100%;
    padding: 12px 8px 0;
    .diagnose-section{
      background: #FFF;
      border-radius: 6px;
      padding: 20px 16px 1px;

      .diagnose-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 16px;
            line-height: 16px;
            color: @error;
            margin-left: 1px;
          }
        }
      }
      .selector-item{
        height: 32px;
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #E0E6E6;
        background: #F7F7F7;
        color: #999;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        transition: all .1s;
        &:first-child{
        margin-right: 16px;
        }
        &.selected{
          border-color: @xile;
          background: @xile;
          color: #FFF;
        }
      }
      .info-textarea{
        width: 100%;
        height: 96px;
        background: #F7F7F7;
        border-radius: 4px;
        padding: 12px;
        font-size: 14px;
        line-height: 20px;
        color: @black;
        resize: none;
      }
      .text-limit{
        position: absolute;
        right: 8px;
        bottom: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .diagnose-info-item{
        margin-bottom: 32px;
        .info-content{
          margin-top: 12px;
          position: relative;
          .patient-info{
            font-size: 18px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
          }
        }
      }

    }
    .diagnose-bottom-control{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 0;
      .botton-button{
        @button-base();
        height: 40px;
        &.save{
          width: 128px;
          @button-border();
          .xile-alpha(0.05);
          &:disabled{
            opacity: .6;
          }
        }
        &.send{
          margin-left: 15px;
          flex: 1;
        }
      }
    }
    .popup-wrapper{
      position: relative;
      width: 100%;
      height: 100%;
      background: #FFF;
      .popup-header{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
        background: #F3F3F3;
        z-index: 100;
        .close-popup{
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          font-size: 13px;
          color: @black;
          font-weight: normal;
          background: transparent;
          border: 0;
        }
      }
      .prescription-wrapper{
        padding-top: 48px;
        height: calc(100%);
        background: #FAFAFA;
        overflow-y: auto;
        -webkit-overflow-scroll: touch;
        .prescription-list{
          padding: 0 16px 16px;
          .prescription-item{
            margin-top: 12px;
            width: 100%;
            border-radius: 6px;
            overflow-y: hidden;
            box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
            border: 1px solid transparent;
            background: #FFF;
            &.selected{
              border-color: @xile;
            }
            .item-head{
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 48px;
              border-bottom: 1px solid #F3F3F3;
              padding: 0 16px;
              background: #FAFAFA;
              .item-title{
                position: relative;
                padding-left: 19px;
                font-size: 16px;
                line-height: 16px;
                font-weight: bold;
                color: @black;
                &::after{
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 4px;
                  height: 16px;
                  background: @xile;
                  border-radius: 2px;
                }
              }
              .sub-title{
                max-width: 170px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 14px;
                color: @black;
              }
            }
            .prescription-card-content{
              padding: 20px;
              font-size: 14px;
              line-height: 24px;
              color: #666;
            }
          }
        }
      }
    }
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .warning-text{
        width: 80%;
        font-size: 15px;
        line-height: 21px;
        font-weight: bold;
        color: @black;
      }
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin-left: 4px;
          color: @error;
        }
      }
      .control{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .save-content{
      padding: 29px 0 47px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .save-input{
        .save-title{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          font-weight: bold;
        }
        .save-text{
          position: relative;
          width: 287px;
          height: 48px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-top: 12px;
          overflow: hidden;
          .save-typer{
            width: 100%;
            padding: 17px 12px;
            font-size: 14px;
            line-height: 14px;
            color: @black;
            background: #F7F7F7;
          }
          .text-limit{
            position: absolute;
            bottom: 8px;
            right: 8px;
            font-size: 12px;
            line-height: 12px;
            color: #999;
          }
        }
      }
      .save-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import stepper from '@/components/Common/stepper'
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {
        hasPresData: false,
        // 电子处方
        presUploader: null,
        presPreview: '',
        presFile: null,
        presPath: '',
        // 处方剂型
        formulationType: parseInt(this.$route.query.type),
        previewShow: false,
        previewList: [
          require('@/assets/images/icons/phpto-pres-example.jpg')

        ],
        imageIndex: 0,
        // 患者信息
        patientInfo: {},
        // 性别
        drugs: '',
        drugsError: false,
        drugsErrorMsg: '请选择药材类型',
        drugsData: [{
            label: '中药饮片',
            value: 1
          },
          {
            label: '配方颗粒',
            value: 2
          },
        ],
        drugsPickerShow: false,
        submitting: false
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      xDialog,
      stepper,
      numberInput
    },
    created() {
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });
          wx.checkJsApi({
              jsApiList: ['chooseImage', 'uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function(res) {
                console.log(res.checkResult)
                if(res.checkResult.chooseImage&&res.checkResult.uploadImage){
                  console.log('俩接口正确')
                }
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              }
          });
        }
      })
      // 获取患者基本信息以及处方基本信息
      this.$root.post('/getInfo', {
        doc_id: this.userInfo.user_id,
        pat_id: this.$route.query.pat_id
      }).then(data => {
        //console.log(data)
        this.patientInfo = data || {};

      })

      this.$root.post('/getPhotoPretData', {
        doc_id: this.userInfo.user_id,
        pat_id: this.$route.query.pat_id
      }).then(data => {
        if (data.has_data) {
          this.presPreview = data.electronic_img;
          this.presPath = data.electronic_img;
          this.drugs = data.type;
          this.hasPresData = true;
        } else {

        }


      })
    },
    mounted() {
      this.setUpload(this.presUploader, 'uploadPres', 'presFile', 'presPreview');

    },
    methods: {
      wxUpload() {
        let _this = this;
        var int = 0;
        var serverIdArr = new Array();
        var localIdArr = new Array();
         _this.presFile={};
         _this.presFile.status=1;
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {
            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            localIdArr = localIds;
            wx.uploadImage({ //根据本地ID获得微信服务器ID
              localId: localIds[int].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function(res) {
                var serverId = res.serverId; // 返回图片的服务器端ID
                console.log("serverid:" + serverId)
                _this.$root.post('/getWxImg', {
                  id: serverId,
                  type: 1
                }).then(data => {
                  console.log("图片下载")
                  console.log(data);
                  if (data.status == 1) {
                    _this.presPath = data.url;
                    _this.presPreview=data.url;
                    _this.presFile.status=5;
                  } else {
                    _this.$notify('发送图片失败');
                  }
                })


              },
              fail(err) {
                console.log('error');
                _this.$toast.clear();
                _this.$notify(`上传图片报错${JSON.stringify(err)}`);
              }
            });
          }
        });

      },
      submit() {
        //this.presPath = 'http://xilegov.oss-cn-beijing.aliyuncs.com/doctor/wairsitZCsS8xrsBxkyhPcSCWxBrsBkd.jpeg';
        if (!this.drugs) {
          this.$notify('请选择药品类型');
          return;
        }
        if (!this.presPath) {
          this.$notify("请上传电子处方");
          return;
        }

        this.submitting = true;
        // 整合提交数据
        let postData = {
          electronic_img: this.presPath,
          pat_id: this.$route.query.pat_id,
          doc_id: this.userInfo.user_id,
          type: this.drugs,
          company_name: this.drugs //暂时药房和配方类型一致
        }

        this.$root.post('/createphotopres', postData).then(data => {
          this.submitting = false;
          if (data.status == 1) {
            console.log(data)
            this.$notify({
              background: '#00848A',
              message: '处方上传成功！'
            });
            this.$router.push('/doctor/consulting-room');

          } else {
            this.$notify(data.msg);
          }
        })

      },
      confirmDrugs(value) {
        this.drugs = value.value;
        console.log(this.drugs)
        this.drugsPickerShow = false;
      },
      previewImage(list, index) {
        //console.log(list)
        this.previewList = list;
        this.imageIndex = index;
        this.previewShow = true;
      },
      // 上传单张函数
      setUpload(obj, id, file, preview) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              console.log(files);
              files.forEach(item => {
                let fileName = item.name;
                _this.$root.previewUploadImage(item, (imgSrc) => {
                  _this[preview] = imgSrc;
                })
              })
              _this[file] = files[0];
              _this.$root.setUploadParam(up, '', false);
              console.log(_this[file])
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true);
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this.presPath = res.path;
                console.log(_this.presPath);
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      }
    },
    filters: {
      floatTypeFilter(type) {
        if (type == 'plus') {
          return '+';
        } else {
          return '-';
        }
      },
      formulationTypeFilter(type) {
        switch (type) {
          case 1:
            return '中药饮片';
            break;
          case 2:
            return '配方颗粒';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/diagnosePhoto.vue